<div
  class="card--base card--size-{{ size }} card--rounded-{{
    rounded
  }} card--spacingBottom-{{ spacingBottom }}"
  [ngClass]="{
    'card--background': background,
    'card--full-height': fullHeight,
    'card--partial-full-height': partialFullHeight,
    'card--border': border,
  }"
>
  <ng-content></ng-content>
</div>
